/**
 * @file regex.js
 * @author Rishikesh
 * @date 2024-09-24
 * @description Simple function components with all regex validations used.
 */
module.exports = {
  // Email validation (standard email format with basic RFC compliance)
  emailRegex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  // Phone number validation (optional country code, allows digits, and dashes)
  phoneNumberRegex: /^[0-9]{10,}$/,
  // Password validation (minimum 8 characters, at least 1 letter, 1 number, and 1 special character)
  passwordRegex:
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
  // Number validation (only digits, allows optional decimal point)
  numberRegex: /^\d+(\.\d+)?$/,
};
